import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export default function Section({ id, title, subtitle, children }) {
    const reduce = useReducedMotion();

    const fadeUp = reduce
        ? {}
        : {
              initial: { opacity: 0, y: 10 },
              whileInView: { opacity: 1, y: 0 },
              viewport: { once: true },
          };

    const fadeUpTitle = reduce
        ? {}
        : {
              initial: { opacity: 0, y: 10 },
              whileInView: { opacity: 1, y: 0 },
              viewport: { once: true },
              transition: { duration: 0.5, delay: 0.1 },
          };

    const fadeContent = reduce
        ? {}
        : {
              initial: { opacity: 0, y: 24 },
              whileInView: { opacity: 1, y: 0 },
              viewport: { once: true, amount: 0.1 },
              transition: { duration: 0.6, delay: 0.2, ease: "easeOut" },
          };

    return (
        <section id={id} className="py-20 px-6 max-w-6xl mx-auto">
            <div className="mb-12 max-w-2xl">
                {subtitle ? (
                    <motion.p
                        {...fadeUp}
                        transition={reduce ? undefined : { duration: 0.5 }}
                        className="font-mono text-[11px] font-bold tracking-[0.28em] uppercase text-stone-500 dark:text-stone-500 mb-3"
                    >
                        {subtitle}
                    </motion.p>
                ) : null}
                {title ? (
                    <motion.h2
                        {...fadeUpTitle}
                        className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-black dark:text-white"
                    >
                        {title}
                    </motion.h2>
                ) : null}
            </div>
            <motion.div {...fadeContent}>{children}</motion.div>
        </section>
    );
}
